export enum DispatcherCompanyCodes {
  hugo = "hugo",
  demo = "demo",
}
